import styled from 'styled-components'
import { FormGroup as FormGroupOriginal, FormFeedback } from 'reactstrap'

import { COLOURS } from 'resources'

import RoundedButton from 'components/RoundedButton'
import TextInput from 'components/TextInput'

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  max-width: 350px;
  width: 100%;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  text-align: left;
  margin: 50px 0;
`

export const WelcomeTitle = styled.div`
  font-weight: 700;
  font-style: italic;
  font-size: 16px;
`

export const WelcomeMessageContainer = styled.div`
  margin-top: 15px;
  font-family: 'Druk', sans-serif;
  font-size: 80px;
  line-height: 1;
  justify-content: column;
`

export const WelcomeMessageText = styled.span``

export const WelcomeMessageRedText = styled.span`
  color: ${COLOURS.secondaryRed1};
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
`

export const FormGroup = styled(FormGroupOriginal)`
  margin-top: 35px;
  margin-bottom: 30px;
`

export const FormResponse = styled(FormFeedback)`
  padding-left: 0.25rem !important;
`

export const UsernameInput = styled(TextInput)`
  margin-bottom: 15px;
`

export const SignInButton = styled(RoundedButton)`
  margin-top: 12px;
`
